<template>
  <base-logo-loader :is-loading="isInitialLoading" />
  <section
    ref="dirPageRef"
    class="dir-page animate__animated animate__fadeIn"
    :class="{ 'dir-page--split': mapOpen && !$device.isMobile }"
  >
    <div ref="stickyHeadRef" class="dir-page__sticky-head">
      <directory-search-top-bar
        :search="search"
        :property-type="selectedPropertyType[0]"
        :all-filters-count="allFiltersCount"
        :property-checkboxes="subtypeCheckboxes"
        :country-checkboxes="countryCheckboxes"
        :handle-property-type-checkbox-click="handleSubtypeCheckboxClick"
        :handle-country-checkbox-click="handleCountryCheckboxClick"
        :handle-country-reset="handleCountryReset"
        :update-slider-filter="updateSliderFilter"
        :reset-slider-filter="resetSliderFilter"
        @search="debouncedHandleMobilSearch"
        @open-all-filters="allFiltersOpen = true"
      >
        <template #actions>
          <base-button
            v-if="$device.isMobile"
            ref="sortButtMobileRef"
            class="dir-page__sort-button dir-page__sort-button--mobile"
            :class="{ 'sort-active': Object.keys(orderFilters?.order).length }"
            :text="$t('search_filters.fr_sort')"
            size="xss"
            variant="light_bordered"
            icon-name="base/ArrowsDownUp"
            icon-size="16px"
            bold-text
          />
          <q-menu
            v-if="$device.isMobile"
            :target="sortButtMobileRef"
            class="sorting-menu"
            anchor="bottom right"
            self="top right"
            :offset="[0, 10]"
          >
            <div class="menu">
              <div
                v-for="(item, index) in sortingFilters"
                :key="item.id"
                class="list-container"
              >
                <ul>
                  <li>
                    <button
                      v-close-popup
                      style="justify-content: flex-start; gap: 12px"
                      @click="sortEstates(item)"
                    >
                      <p
                        class="text-body-2 text-black-monochrome"
                        :style="{
                          fontWeight:
                            item.asc || item.desc ? 'bold' : 'normal',
                        }"
                      >
                        {{ item.label }}
                      </p>
                      <base-icon
                        size="22px"
                        :name="`base/${
                          item.asc || item.desc ? 'ArrowDown' : 'ArrowsDownUp'
                        }`"
                        :rot="item.asc ? '0.5turn' : '0deg'"
                        :color="
                          item.asc || item.desc
                            ? 'var(--black-monochrome)'
                            : 'var(--black-monochrome-60)'
                        "
                      />
                    </button>
                  </li>
                </ul>
                <q-separator
                  v-if="sortingFilters.length !== index + 1"
                  style="width: 100%"
                />
              </div>
            </div>
          </q-menu>
        </template>
      </directory-search-top-bar>

      <directory-search-active-chips
        :chips="activeChips"
        @remove="handleActiveChipRemove"
        @clear-all="dropAllFilters"
      />
    </div>

    <directory-search-all-filters-drawer
      v-model="allFiltersOpen"
      :property-type="selectedPropertyType[0]"
      :results-count="objsAmount || 0"
      :show-rating="false"
      :bedroom-checkboxes="bedroomCheckboxes"
      :bathroom-checkboxes="bathroomCheckboxes"
      :stage-checkboxes="stageCheckboxes"
      :company-checkboxes="companyCheckboxes"
      :documents-checkboxes="documentsCheckboxes"
      :rating-checkboxes="ratingCheckboxes"
      :country-checkboxes="countryCheckboxes"
      :subtype-checkboxes="subtypeCheckboxes"
      :handle-bedroom-checkbox-click="handleBedroomCheckboxClick"
      :handle-bathroom-checkbox-click="handleBathroomCheckboxClick"
      :handle-stage-checkbox-click="handleStageCheckboxClick"
      :handle-company-checkbox-click="handleCompanyCheckboxClick"
      :handle-documents-checkbox-click="handleDocumentsCheckboxClick"
      :handle-rating-checkbox-click="handleRatingCheckboxClick"
      :handle-country-checkbox-click="handleCountryCheckboxClick"
      :handle-subtype-checkbox-click="handleSubtypeCheckboxClick"
      :update-slider-filter="updateSliderFilter"
      @clear-all="dropAllFilters"
    />

    <div
      class="dir-page__content"
      :class="{ 'dir-page__content--split': mapOpen && !$device.isMobile }"
    >
      <div class="dir-page__list">
        <span class="dir-page__sort">
          <h5 class="text-body-1 text-bold text-black-monochrome">
            {{ objsAmount || 0 }} {{ $t("search_filters.fr_found") }}
          </h5>
          <div class="dir-page__sort-actions">
            <base-button
              v-if="!$device.isMobile"
              :text="
                mapOpen
                  ? $t('directory.filters.hide_map')
                  : $t('directory.filters.show_map')
              "
              size="xss"
              variant="light_bordered"
              icon-name="base/MapPin"
              icon-size="16px"
              bold-text
              class="dir-page__sort-button"
              :class="{ 'sort-active': mapOpen }"
              @click="toggleMap"
            />
            <base-button
              v-if="!$device.isMobile"
              ref="sortButtRef"
              class="dir-page__sort-button"
              :class="{ 'sort-active': Object.keys(orderFilters?.order).length }"
              :text="$t('search_filters.fr_sort')"
              size="xss"
              variant="light_bordered"
              icon-name="base/ArrowsDownUp"
              icon-size="16px"
              bold-text
            />
            <q-menu
              v-if="!$device.isMobile"
              :target="sortButtRef"
              class="sorting-menu"
              anchor="bottom right"
              self="top right"
              :offset="[0, 10]"
            >
              <div class="menu">
                <div
                  v-for="(item, index) in sortingFilters"
                  :key="item.id"
                  class="list-container"
                >
                  <ul>
                    <li>
                      <button
                        v-close-popup
                        style="justify-content: flex-start; gap: 12px"
                        @click="sortEstates(item)"
                      >
                        <p
                          class="text-body-2 text-black-monochrome"
                          :style="{
                            fontWeight:
                              item.asc || item.desc ? 'bold' : 'normal',
                          }"
                        >
                          {{ item.label }}
                        </p>
                        <base-icon
                          size="22px"
                          :name="`base/${
                            item.asc || item.desc ? 'ArrowDown' : 'ArrowsDownUp'
                          }`"
                          :rot="item.asc ? '0.5turn' : '0deg'"
                          :color="
                            item.asc || item.desc
                              ? 'var(--black-monochrome)'
                              : 'var(--black-monochrome-60)'
                          "
                        />
                      </button>
                    </li>
                  </ul>
                  <q-separator
                    v-if="sortingFilters.length !== index + 1"
                    style="width: 100%"
                  />
                </div>
              </div>
            </q-menu>
          </div>
        </span>

        <div
          v-show="!skeletonLoader"
          class="dir-page__list-wrapper animate__animated animate__fadeIn"
        >
          <Transition v-if="!skeletonLoader && !isNoData" name="fade">
            <div class="dir-page__list-grid">
              <listing-card
                v-for="item in itemsArray"
                :key="item.id"
                :estate="item"
                variant="row"
                :property-type="selectedPropertyType[0]"
                source="directory"
              />
            </div>
          </Transition>
          <search-page-no-objects v-if="isNoData">
            <template #default>
              <h3
                class="text-head-2 text-bold mobile-font--h4 text-black-monochrome"
              >
                {{ $t("search_filters.fr_no_object.no_result") }}
              </h3>
              <p class="text-body-1 mobile-font--b2 text-black-monochrome">
                {{ $t("search_filters.fr_no_object.couldnt_find") }}
              </p>
            </template>
          </search-page-no-objects>
          <base-paginator
            :limit="limit"
            :offset="offset"
            :items-amount="objsAmount ?? 0"
            @change="onPaginator"
          />
        </div>
        <div
          v-show="skeletonLoader"
          class="dir-page__list-skeleton animate__animated animate__fadeIn"
        >
          <q-skeleton
            v-for="(q, idx) in Array(3).fill(null)"
            :key="idx"
            class="search-skeleton search-skeleton__list"
          />
        </div>
      </div>

      <directory-search-map-panel
        v-if="mapOpen && !$device.isMobile"
        class="dir-page__map"
      />
    </div>

    <directory-search-map-panel
      v-if="mapOpen && $device.isMobile"
      :full-screen="true"
      @close="mapOpen = false"
    />

    <ClientOnly>
      <Teleport to="body">
        <button
          v-if="$device.isMobile && !allFiltersOpen && !mapUnitOpen"
          type="button"
          class="dir-page__map-toggle-pill"
          :aria-pressed="mapOpen"
          @click="toggleMap"
        >
          <base-icon
            :name="mapOpen ? 'base/Menu' : 'base/MapPin'"
            size="18px"
            color="currentColor"
          />
          <span>{{
            mapOpen
              ? $t("directory.filters.show_list")
              : $t("directory.filters.show_map")
          }}</span>
        </button>
      </Teleport>
    </ClientOnly>
  </section>
</template>

<script setup lang="ts">
import { filtersStore } from "~/store/search_filters";
import getRoute from "~/utilities/configs/apiMap";
import { apiPost } from "~/services/api";
import type { PropertyItem } from "~/types/search-page-items";
import eventBus from "~/utilities/composables/eventBus";
import { transformQueryToObject } from "~/utilities/helpers/query/transformQueryToObject";
import type {
  FilterCheckbox,
  ExpandFiltersMap,
  CanResetAnim,
  PropertyTypes,
  PropertySubtype,
} from "~/components/base/navigator/types";
import { PROPERTY_SUBTYPES } from "~/components/base/navigator/types";
import { debounce, isEqual } from "lodash";
import { userStore } from "~/store/user";
import { useAdminStore } from "~/store/admin";
import { countryNames as countryLocalNames } from "~/utilities/constants/countryCodes";
import {
  convertServerStars,
  getServerStars,
} from "~/utilities/helpers/review/convertServerRating";

interface Props {
  hideNavTitle?: boolean;
  hideDesktopSearch?: boolean;
}

defineProps<Props>();

type FilterItem = {
  label: string;
  value: string[];
  asc: boolean;
  desc: boolean;
  id: number;
};

const useFiltersStore = filtersStore();
const useUserStore = userStore();
const adminStore = useAdminStore();
const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const localePath = useLocalePath();

const itemsArray = ref<PropertyItem[]>([]);

const limit = ref(9);
const offset = ref(0);
const skeletonLoader = ref(false);
const isInitialLoading = ref(false);
const isFilterLoader = ref(false);
const showFiltersSugg = ref(false);
const isLastPage = ref(false);
const isNoData = ref(false);
const isSold = (availableSupply: string | null | undefined) => !availableSupply;
const objsAmount = ref<number | null>(0);
const sortButtRef = ref<HTMLElement | null>(null);
const sortButtMobileRef = ref<HTMLElement | null>(null);
const orderFilters = ref<Record<string, string | any>>({ order: {} });
const expandFiltersMap = reactive<ExpandFiltersMap>({
  price_range: { expanded: true, canReset: "init" as CanResetAnim },
  min_invest: { expanded: true, canReset: "init" as CanResetAnim },
  irr: { expanded: true, canReset: "init" as CanResetAnim },
  apr: { expanded: true, canReset: "init" as CanResetAnim },
  subtype: { expanded: true, canReset: "init" as CanResetAnim },
  bedroom: { expanded: true, canReset: "init" as CanResetAnim },
  bathroom: { expanded: true, canReset: "init" as CanResetAnim },
  countryId: { expanded: true, canReset: "init" as CanResetAnim },
  stage: { expanded: true, canReset: "init" as CanResetAnim },
  property_type: { expanded: true, canReset: "init" as CanResetAnim },
  providerIds: { expanded: true, canReset: "init" as CanResetAnim },
  documents: { expanded: true, canReset: "init" as CanResetAnim },
  rating: { expanded: true, canReset: "init" as CanResetAnim },
});

const sortingFilters = ref([
  {
    label: t("search_filters.fr_most_viewd"),
    value: ["viewsForAllTime"],
    asc: false,
    desc: false,
    id: 1,
  },
  {
    label: t("search_card.fr_price"),
    value: ["priceUSD"],
    asc: false,
    desc: false,
    id: 2,
  },
  {
    label: t("search_filters.fr_price"),
    value: ["tokenomics", "priceUSD"],
    asc: false,
    desc: false,
    id: 3,
  },
  {
    label: t("search_card.fr_apr"),
    value: ["apr"],
    asc: false,
    desc: false,
    id: 4,
  },
]);

const sortingFiltersMobile = ref([
  {
    label: `${t("search_card.fr_price")} : ${t("search_filters.desc")}`,
    value: ["priceUSD"],
    asc: false,
    desc: true,
    id: 1,
  },
  {
    label: `${t("search_card.fr_price")} : ${t("search_filters.asc")}`,
    value: ["priceUSD"],
    asc: true,
    desc: false,
    id: 2,
  },
  {
    label: `${t("search_card.fr_token")} : ${t("search_filters.asc")}`,
    value: ["tokenomics", "priceUSD"],
    asc: true,
    desc: false,
    id: 3,
  },
  {
    label: `${t("search_card.fr_token")} : ${t("search_filters.desc")}`,
    value: ["tokenomics", "priceUSD"],
    asc: false,
    desc: true,
    id: 4,
  },
  {
    label: `${t("search_card.fr_apr")}`,
    value: ["apr"],
    asc: false,
    desc: false,
    id: 5,
  },
]);

const selectedFilterMobile = ref<
  | {}
  | {
      label: string;
      value: string[];
      asc: boolean;
      desc: boolean;
      id: number;
    }
>({});

const selectedRooms = ref<string[]>([]);
const selectedCompanies = ref<string[]>([]);
const selectedRating = ref<string[]>([]);
const selectedBathRooms = ref<string[]>([]);
const selectedCountry = ref<string[]>([]);
const selectedStage = ref<string[]>([]);
const selectedDocuments = ref<string[]>([]);
const selectedSubtype = ref<string[]>([]);
const selectedPropertyType = ref<PropertyTypes[]>(["estates"]);
const selectedDocument = ref(false);
const search = ref<string>("");

const mapOpen = ref(route.query.view === "map");
const allFiltersOpen = ref(false);
const { isMobile } = useDevice();

// The filter pills + active chips are pinned to the top of the viewport (sticky)
// on desktop. Their combined height is variable (chips wrap, active-chips row
// appears/disappears), so it is measured and published as a CSS var that the
// sort row and the map panel use as their own sticky `top` offset.
const dirPageRef = ref<HTMLElement | null>(null);
const stickyHeadRef = ref<HTMLElement | null>(null);
let stickyHeadResizeObserver: ResizeObserver | null = null;

onMounted(() => {
  if (!import.meta.client || !stickyHeadRef.value || !dirPageRef.value) return;
  const updateStickyHeadHeight = () => {
    const height = stickyHeadRef.value?.offsetHeight ?? 0;
    dirPageRef.value?.style.setProperty("--dir-sticky-head-h", `${height}px`);
  };
  updateStickyHeadHeight();
  stickyHeadResizeObserver = new ResizeObserver(updateStickyHeadHeight);
  stickyHeadResizeObserver.observe(stickyHeadRef.value);
});

onBeforeUnmount(() => {
  stickyHeadResizeObserver?.disconnect();
  stickyHeadResizeObserver = null;
});

watch(
  () => route.query.view,
  (view) => {
    mapOpen.value = view === "map";
  }
);

const MOBILE_MAP_LOCK_CLASS = "dir-page--map-scroll-locked";
const applyMobileMapScrollLock = (locked: boolean) => {
  if (!import.meta.client) return;
  document.body.classList.toggle(MOBILE_MAP_LOCK_CLASS, locked);
};

watch(
  () => mapOpen.value && isMobile,
  (lock) => applyMobileMapScrollLock(lock),
  { immediate: true }
);

onBeforeUnmount(() => applyMobileMapScrollLock(false));

// Mobile: hide the list/map toggle pill while a unit bottom-sheet card is open
// on the map (the sheet covers the bottom of the screen, where the pill sits).
const mapUnitOpen = ref(false);
const onMapUnitOpen = () => {
  mapUnitOpen.value = true;
};
const onMapUnitClose = () => {
  mapUnitOpen.value = false;
};

const toggleMap = () => {
  mapOpen.value = !mapOpen.value;
  if (!mapOpen.value) mapUnitOpen.value = false;
  const newQuery = { ...route.query };
  if (mapOpen.value) {
    newQuery.view = "map";
  } else {
    delete newQuery.view;
  }
  router.replace({ query: newQuery });
};

const getFilterCheckboxes = (args: {
  serverObj: Record<string, any> | null | undefined;
  values: Ref<string[]>;
  labelAlone?: string;
  labelMany?: string;
  stringKeys?: boolean;
  otherLable?: string;
}) => {
  if (!args.serverObj) return [];
  const checkboxes: FilterCheckbox[] = [];
  let othersCount = 0;

  Object.entries(args.serverObj).forEach(([key, value]) => {
    const checkboxNumber = parseInt(key, 10);

    if (
      !args.stringKeys &&
      (isNaN(checkboxNumber) || checkboxNumber < 1 || checkboxNumber > 5)
    ) {
      othersCount += value;
    } else {
      let label: string;

      if (args.stringKeys) {
        label = key;
      } else {
        if (checkboxNumber === 1) {
          label = args.labelAlone ? `${key} ${args.labelAlone}` : key;
        } else {
          label = args.labelMany
            ? `${key} ${args.labelMany}`
            : args.labelAlone
              ? `${key} ${args.labelAlone}`
              : key;
        }
      }

      checkboxes.push({
        label,
        count: value,
        checked: args.values.value.includes(key),
        server_label: key,
      });
    }
  });

  if (othersCount > 0) {
    checkboxes.push({
      label: args.otherLable ?? t("search_filters.fr_others"),
      count: othersCount,
      checked: args.values.value.includes("null"),
      server_label: "null",
    });
  }

  return reactive(checkboxes);
};

// The provider filter is driven by the `provider` aggregation returned by the
// stats route (`POST /units/stats`): its keys are the providerIds that actually
// have units, so only providers with listings appear. `savedStats` (the initial
// unfiltered snapshot) gives the stable list; `currentStats` gives the live,
// filter-aware counts. Provider names/labels are resolved from the providers
// list (`GET /api/providers`, kept in the admin store).
const companyCheckboxes = computed<FilterCheckbox[]>(() => {
  const providers = adminStore.$state.providers;
  const listStats = useFiltersStore.savedStats?.provider as
    | Record<string, number>
    | undefined;
  if (!providers || !listStats) return [];
  const liveStats = useFiltersStore.currentStats?.provider as
    | Record<string, number>
    | undefined;

  return Object.keys(listStats)
    .filter((providerId) => providerId !== "null")
    .map((providerId) => {
      const provider = providers.find((p) => p.id === providerId);
      return {
        label: provider?.name ?? providerId,
        count: liveStats?.[providerId] ?? 0,
        checked: selectedCompanies.value.includes(providerId),
        server_label: providerId,
      } as FilterCheckbox;
    });
});

const bedroomCheckboxes = computed(() =>
  getFilterCheckboxes({
    serverObj: useFiltersStore.savedStats?.bedroom,
    values: selectedRooms,
    labelAlone: t("search_filters.fr_bed"),
    labelMany: t("search_filters.fr_beds"),
  })
);
const ratingCheckboxes = computed(() =>
  getFilterCheckboxes({
    serverObj: useFiltersStore.savedStats?.rating,
    values: selectedRating,
    otherLable: t("search_filters.fr_no_ratings"),
  })
);

const documentsCheckboxes = computed(
  () =>
    [
      {
        label: t("search_filters.documents"),
        count: useFiltersStore.currentStats?.hasDocuments["true"],
        checked: selectedDocument.value,
        server_label: "hasDocument",
        filterUpdate: useFiltersStore.updateEstateFilters,
      },
    ] as FilterCheckbox[]
);

const bathroomCheckboxes = computed(() =>
  getFilterCheckboxes({
    serverObj: useFiltersStore.savedStats?.bathroom,
    values: selectedBathRooms,
    labelAlone: t("search_filters.fr_bath"),
    labelMany: t("search_filters.fr_baths"),
  })
);

const countryCheckboxes = computed(() =>
  getFilterCheckboxes({
    serverObj: useFiltersStore.savedStats?.country,
    values: selectedCountry,
    labelAlone: t("compare.country"),
    labelMany: t("compare.country"),
    stringKeys: true,
  })
);

const stageCheckboxes = computed(() =>
  getFilterCheckboxes({
    serverObj: useFiltersStore.savedStats?.stage,
    values: selectedStage,
    labelAlone: t("search_filters.fr_stage"),
    stringKeys: true,
  })
);

const subtypeCheckboxes = computed(() => {
  const counts =
    (
      useFiltersStore.savedStats as unknown as {
        subtype?: Partial<Record<PropertySubtype, number>>;
      }
    )?.subtype ?? {};
  return PROPERTY_SUBTYPES.map<FilterCheckbox>((key) => ({
    label: t(`directory.filters.subtype.${key.toLowerCase()}`),
    count: counts[key] ?? 0,
    checked: selectedSubtype.value.includes(key),
    server_label: key,
  }));
});

const fetchSearchPage = async (filters?: any, keepOffset = false) => {
  // Any change other than direct pagination (filter, sort, search) must reset
  // the offset back to the first page — otherwise a stale high offset can land
  // outside the newly filtered result set and the API returns an empty page.
  if (!keepOffset) {
    offset.value = 0;
  }
  skeletonLoader.value = true;
  isNoData.value = false;
  filters = transformQueryToObject(filters);
  if (filters.tokenPrice) {
    filters[
      BASE_CURRENCY.value.code === "USD"
        ? "tokenomics.priceUSD"
        : "tokenomics.price"
    ] = {
      gte: filters.tokenPrice.gte,
      lte: filters.tokenPrice.lte,
    };
    delete filters.tokenPrice;
  }
  if (!Array.isArray(filters.subtype) || !filters.subtype.length) {
    delete filters.subtype;
  }

  if (Object.keys(orderFilters.value?.order).length) {
    filters = { ...filters, ...orderFilters.value };
  } else {
    delete filters.order;
  }
  const cleanedFilters = filters;
  Object.keys(cleanedFilters).forEach((key) => {
    if (
      cleanedFilters["countryId"] &&
      Array.isArray(cleanedFilters["countryId"]) &&
      !cleanedFilters["countryId"].length
    ) {
      delete cleanedFilters["countryId"];
    }
  });

  const url = getRoute({ endpont: "post_units" });
  if (useUserStore.$state.isInSystem) {
    await useUserStore.fetchUserData();
  }
  const data = await apiPost({
    url: url,
    body: { limit: limit.value, offset: offset.value, ...cleanedFilters },
    headers: {
      Authorization:
        useUserStore.$state.role === "admin"
          ? null
          : `Bearer ${useCookie("acc_token").value}`,
    },
  }).finally(() => {
    setTimeout(() => {
      skeletonLoader.value = false;
    }, 500);
  });
  if (!data?.data?.value) {
    isNoData.value = true;
    isLastPage.value = true;
    objsAmount.value = 0;
    return;
  }
  const response = data?.data.value as {
    count: number | null;
    rows: PropertyItem[] | null;
  };

  if (response.rows?.length) {
    itemsArray.value = response.rows;
  } else {
    isNoData.value = true;
    itemsArray.value = [];
  }
  objsAmount.value = response.count;
};

const updateFilters = async (noLoader?: boolean, obj?: Record<string, any>) => {
  if (!noLoader) {
    isFilterLoader.value = true;
  }
  const params = obj ?? transformQueryToObject(route.query);
  if (params.tokenPrice) {
    params[
      BASE_CURRENCY.value.code === "USD"
        ? "tokenomics.priceUSD"
        : "tokenomics.price"
    ] = {
      gte: params.tokenPrice.gte,
      lte: params.tokenPrice.lte,
    };
    delete params.tokenPrice;
  }
  if (!Array.isArray(params.subtype) || !params.subtype.length) {
    delete params.subtype;
  }
  const res = await useFiltersStore.updateEstateFilters(
    isInitialLoading.value,
    params
  );
  reCountCheckboxes();
  setTimeout(() => {
    isFilterLoader.value = false;
  }, 500);
};

const reCountCheckboxes = () => {
  const updateableKeys: string[] = [
    "bedroom",
    "bathroom",
    "country",
    "stage",
    "rating",
  ];
  updateableKeys.forEach((key) => {
    const savedStats =
      useFiltersStore.savedStats[
        key as keyof typeof useFiltersStore.savedStats
      ] || {};
    const currentStats =
      useFiltersStore.currentStats?.[
        key as keyof typeof useFiltersStore.currentStats
      ] || {};

    const updatedStats = Object.fromEntries(
      Object.keys(savedStats).map((k) => [k, currentStats[k] ?? 0])
    );

    useFiltersStore.savedStats[key] = updatedStats;
  });
};

const updateSliderFilter = async (
  key: keyof typeof expandFiltersMap,
  paramName: string,
  values: Record<string, Record<string, number | string>>
) => {
  const nestedValues = values[paramName];
  const queryParams = Object.fromEntries(
    Object.entries(nestedValues).map(([subKey, value]) => [
      `${paramName}[${subKey}]`,
      value.toString(),
    ])
  );

  const query = {
    ...route.query,
    ...queryParams,
  };
  router.push({
    query,
  });

  expandFiltersMap[key].canReset = "show";
  await fetchSearchPage(query);
  updateFilters(true, transformQueryToObject(query));
};

const resetSliderFilter = async (
  key: keyof typeof expandFiltersMap,
  paramName: string,
  resetValues: number[],
  isDrop?: boolean
) => {
  if (expandFiltersMap[key].canReset === "hide") return;

  expandFiltersMap[key].canReset = "hide";

  if (!isDrop) {
    const obj: Record<string, any> = {};
    Object.keys(route.query).forEach((key) => {
      if (!key.includes(paramName)) {
        obj[key] = route.query[key];
      }
    });

    router.push({
      query: { ...obj },
    });

    await fetchSearchPage(obj);
    updateFilters(true, transformQueryToObject(obj));
  }

  eventBus.emit(`drop-${paramName}-range`, resetValues);
};

const handleBedroomCheckboxClick = (item: FilterCheckbox) => {
  updateCheckboxFilter("bedroom", item, selectedRooms);
  ifCanResetCheckbox(selectedRooms, "bedroom");
};

const handleBathroomCheckboxClick = (item: FilterCheckbox) => {
  updateCheckboxFilter("bathroom", item, selectedBathRooms);
  ifCanResetCheckbox(selectedBathRooms, "bathroom");
};

const handleRatingCheckboxClick = (item: FilterCheckbox) => {
  updateCheckboxFilter("rating", item, selectedRating);
  ifCanResetCheckbox(selectedRating, "rating");
};

const handleCompanyCheckboxClick = (item: FilterCheckbox) => {
  updateCheckboxFilter("providerIds", item, selectedCompanies);
  ifCanResetCheckbox(selectedCompanies, "providerIds");
};

const handleCountryCheckboxClick = (item: FilterCheckbox) => {
  updateCheckboxFilter("countryId", item, selectedCountry);
  ifCanResetCheckbox(selectedCountry, "countryId");
};

const handleStageCheckboxClick = (item: FilterCheckbox) => {
  updateCheckboxFilter("stage", item, selectedStage);
  ifCanResetCheckbox(selectedStage, "stage");
};

const handleDocumentsCheckboxClick = (item: FilterCheckbox) => {
  updateCheckboxFilter("hasDocument", item, selectedDocuments);
  selectedDocument.value = !selectedDocument.value;
};

const handleSubtypeCheckboxClick = (item: FilterCheckbox) => {
  updateCheckboxFilter("subtype", item, selectedSubtype);
  ifCanResetCheckbox(selectedSubtype, "subtype");
};

const handleSubtypeReset = () => {
  resetCheckboxFilter("subtype", selectedSubtype);
};

const handleStageReset = () => {
  resetCheckboxFilter("stage", selectedStage);
};

const handleCountryReset = () => {
  resetCheckboxFilter("countryId", selectedCountry);
};

const handleBathroomReset = () => {
  resetCheckboxFilter("bathroom", selectedBathRooms);
};
const handleRatingReset = () => {
  resetCheckboxFilter("rating", selectedRating);
};
const handleCompanyReset = () => {
  resetCheckboxFilter("providerIds", selectedCompanies);
};

const handleBedroomReset = () => {
  resetCheckboxFilter("bedroom", selectedRooms);
};

const ifCanResetCheckbox = (
  arr: Ref<string[]>,
  key: keyof typeof expandFiltersMap
) => {
  if (!arr || !arr.value || !arr.value.length) {
    expandFiltersMap[key].canReset = "hide";
  } else {
    expandFiltersMap[key].canReset = "show";
  }
};

const resetCheckboxFilter = async (
  key: keyof typeof expandFiltersMap,
  values: Ref<string[]>,
  isDrop?: boolean
) => {
  expandFiltersMap[key].canReset = "hide";
  values.value = [];
  if (!isDrop) {
    const query = getCheckboxFilterQuery({
      paramName: key,
      array: values.value,
    });
    router.push({ query });
    await fetchSearchPage(query);
    updateFilters(true, transformQueryToObject(route.query));
  }
};

const updateCheckboxFilter = async (
  paramName: string,
  value: FilterCheckbox,
  array: Ref<string[]>
) => {
  const standAloneParams = ["hasDocument"];
  value.checked = !value.checked;
  if (array.value.includes(value.server_label)) {
    array.value = array.value.filter((v) => v !== value.server_label);
  } else {
    array.value.push(value.server_label);
  }
  let newArray: string[] = [];
  if (paramName === "rating") {
    newArray = array.value.map((q) => {
      if (q === "null" || q == null) return q;
      return getServerStars(parseInt(q));
    });
  } else {
    newArray = array.value;
  }

  const query = getCheckboxFilterQuery({
    paramName: paramName,
    array: newArray,
    standAlone: standAloneParams.includes(paramName),
    standValue: value.checked,
  });

  router.push({ query });

  await fetchSearchPage(query);
  updateFilters(true, transformQueryToObject(query));
};

const getCheckboxFilterQuery = (args: {
  paramName: string;
  array: string[];
  standAlone?: boolean;
  standValue?: any;
}) => {
  if (!args.standAlone) {
    const cleanedQuery = Object.fromEntries(
      Object.entries(route.query).filter(
        ([key]) => !key.startsWith(`${args.paramName}[`)
      )
    );

    const queryParams = args.array.map((k, index) => [
      `${args.paramName}[${index}]`,
      k === "null" ? k : !isNaN(parseInt(Number(k))) ? parseInt(Number(k)) : k,
    ]);

    const query = {
      ...cleanedQuery,
      ...Object.fromEntries(queryParams),
    };
    return query;
  } else {
    if (!args.standValue) {
      const query = { ...route.query };
      delete query[args.paramName];
      return query;
    }
    const query = {
      ...route.query,
      [args.paramName]: args.standValue,
    };
    return query;
  }
};

const onPaginator = async (newOffset: number) => {
  offset.value = newOffset;
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  itemsArray.value = [];
  fetchSearchPage(route.query, true);
};

const sortEstates = async (item: FilterItem) => {
  if (!item.asc && !item.desc) {
    item.desc = true;
    item.asc = false;
  } else if (item.desc) {
    item.desc = false;
    item.asc = true;
  } else if (item.asc) {
    item.asc = false;
    item.desc = false;
  }

  sortingFilters.value.forEach((filter) => {
    if (filter.id !== item.id) {
      filter.asc = false;
      filter.desc = false;
    }
  });

  sortingFilters.value.forEach((filter) => {
    const key = filtersKeyMap(filter.value[0]);
    if (filter.asc || filter.desc) {
      orderFilters.value.order[key] = filter.asc ? "asc" : "desc";
    } else {
      delete orderFilters.value.order[key];
    }
  });

  await gatherCompanies();
  await fetchSearchPage(route.query);
};

const filtersKeyMap = (key: string) => {
  switch (key) {
    case "tokenomics":
      return "tokenomics.priceUSD";
    case "apr":
      return "estate.apr";
    default:
      return key;
  }
};

const sortEstatesMobile = async (filter: {
  label: string;
  value: string[];
  asc: boolean;
  desc: boolean;
  id: number;
}) => {
  orderFilters.value.order = {};

  const key = filtersKeyMap(filter.value[0]);
  if (filter.asc || filter.desc || key === "estate.apr") {
    orderFilters.value.order[key] = filter.asc ? "asc" : "desc";
  }
  if (isEqual(selectedFilterMobile.value, filter)) {
    orderFilters.value.order = { viewsForAllTime: "desc" };
    selectedFilterMobile.value = {};
  } else {
    selectedFilterMobile.value = filter;
  }
  await fetchSearchPage(route.query);
};

const ifCheckboxChecked = () => {
  const updateableKeys: {
    key: keyof typeof expandFiltersMap;
    arr: Ref<string[]>;
  }[] = [
    { key: "bedroom", arr: selectedRooms },
    { key: "bathroom", arr: selectedBathRooms },
    { key: "countryId", arr: selectedCountry },
    { key: "stage", arr: selectedStage },
    { key: "providerIds", arr: selectedCompanies },
    { key: "rating", arr: selectedRating },
    { key: "subtype", arr: selectedSubtype },
  ];

  const obj = transformQueryToObject(route.query);
  updateableKeys.forEach((item) => {
    if (!obj[item.key]) return;
    if (item.key === "rating" && Array.isArray(obj[item.key])) {
      obj[item.key] = obj[item.key].map((q) => convertServerStars(q));
    }
    expandFiltersMap[item.key].canReset = "show";
    if (Array.isArray(obj[item.key])) {
      obj[item.key] = obj[item.key].map((item: string | number | null) =>
        String(item).toString()
      );
    }
    item.arr.value = obj[item.key];
  });
  const toBoolean = (value: unknown): boolean =>
    value === "true" ? true : value === "false" ? false : Boolean(value);
  selectedDocument.value = toBoolean(obj?.hasDocument);
};

const ifCanResetSliders = () => {
  const resetableKeys: {
    q_key: string;
    f_key: keyof typeof expandFiltersMap;
  }[] = [
    { q_key: "irr", f_key: "irr" },
    { q_key: "apr", f_key: "apr" },
    { q_key: "minimumInvestment", f_key: "min_invest" },
    { q_key: "tokenPrice", f_key: "price_range" },
    { q_key: "providerIds", f_key: "providerIds" },
  ];
  const queryObject = transformQueryToObject(route.query);
  resetableKeys.forEach((t) => {
    if (queryObject[t.q_key]) {
      expandFiltersMap[t.f_key].canReset = "show";
    }
  });
};

const dropAllFilters = async (noUpdate?: boolean) => {
  router.replace({ path: route.path, query: {} });
  resetCheckboxFilter("stage", selectedStage, true);
  resetCheckboxFilter("documents", selectedDocuments, true);
  selectedDocument.value = !selectedDocument.value;
  resetCheckboxFilter("rating", selectedRating, true);
  resetCheckboxFilter("countryId", selectedCountry, true);
  resetCheckboxFilter("subtype", selectedSubtype, true);
  resetCheckboxFilter("bathroom", selectedBathRooms, true);
  resetCheckboxFilter("bedroom", selectedRooms, true);
  resetCheckboxFilter("providerIds", selectedCompanies, true);
  resetSliderFilter(
    "price_range",
    "tokenPrice",
    [
      useFiltersStore.savedStats?.tokenPriceMin!,
      useFiltersStore.savedStats?.tokenPriceMax!,
    ],
    true
  );
  resetSliderFilter(
    "min_invest",
    "minimumInvestment",
    [
      useFiltersStore.savedStats?.minimumInvestment ?? 0,
      useFiltersStore.savedStats?.maximumInvestment ?? 100,
    ],
    true
  );
  resetSliderFilter(
    "irr",
    "irr",
    [
      useFiltersStore.savedStats?.irrMin ?? 0,
      useFiltersStore.savedStats?.irrMax ?? 100,
    ],
    true
  );
  resetSliderFilter(
    "apr",
    "apr",
    [
      useFiltersStore.savedStats?.aprMin ?? 0,
      useFiltersStore.savedStats?.aprMax ?? 100,
    ],
    true
  );
  Object.keys(expandFiltersMap).forEach((key) => {
    expandFiltersMap[key as keyof typeof expandFiltersMap].canReset = "init";
  });
  if (
    typeof noUpdate !== "boolean" ||
    (typeof noUpdate === "boolean" && !noUpdate)
  ) {
    await fetchSearchPage({});
    updateFilters(true, {});
  }
  nextTick(() => {
    eventBus.emit("clear-directory-search");
  });
};

const ifSearchQuery = () => {
  const searchQuery = route.query.search as string | undefined;
  if (searchQuery) {
    search.value = searchQuery;
  }
};

const handleMobilSearch = (val: string) => {
  search.value = val;
  const newFilters = { ...route.query, search: val };
  router.replace({ query: newFilters });

  fetchSearchPage(newFilters);
  updateFilters(true, transformQueryToObject(newFilters));
};

const debouncedHandleMobilSearch = debounce((val: string) => {
  handleMobilSearch(val);
}, 300);

// Loads the providers list into the admin store so `companyCheckboxes` can map
// providerIds (from the stats aggregation) to display names.
const gatherCompanies = async () => {
  await adminStore.getProviders();
};

const countryLabelLocal = (label: string) => {
  if (!label || label === "null") return t("search_filters.fr_others");
  const localized =
    t(`countries.${label}`) !== `countries.${label}`
      ? t(`countries.${label}`)
      : countryLocalNames[label];
  return localized || label;
};

const allFiltersCount = computed(
  () =>
    selectedCountry.value.length +
    selectedSubtype.value.length +
    selectedRooms.value.length +
    selectedBathRooms.value.length +
    selectedStage.value.length +
    selectedCompanies.value.length +
    (selectedDocument.value ? 1 : 0) +
    selectedRating.value.length
);

const activeChips = computed<
  { key: string; label: string; value: string }[]
>(() => {
  const chips: { key: string; label: string; value: string }[] = [];
  const q = route.query;

  if (selectedCountry.value.length) {
    const values = selectedCountry.value.map((code) => {
      const item = countryCheckboxes.value.find(
        (c) => c.server_label === code
      );
      return countryLabelLocal(item?.label ?? code);
    });
    chips.push({
      key: "country",
      label: t("directory.filters.country"),
      value: values.join(", "),
    });
  }

  if (selectedSubtype.value.length) {
    const values = selectedSubtype.value.map((code) => {
      const item = subtypeCheckboxes.value.find(
        (c) => c.server_label === code
      );
      return item?.label ?? code;
    });
    chips.push({
      key: "subtype",
      label: t("directory.filters.type"),
      value: values.join(", "),
    });
  }

  if (selectedRooms.value.length) {
    const sorted = [...selectedRooms.value].sort(
      (a, b) => Number(a) - Number(b)
    );
    chips.push({
      key: "bedroom",
      label: t("directory.filters.bedrooms"),
      value: sorted.join(", "),
    });
  }

  if (selectedBathRooms.value.length) {
    const sorted = [...selectedBathRooms.value].sort(
      (a, b) => Number(a) - Number(b)
    );
    chips.push({
      key: "bathroom",
      label: t("directory.filters.bathrooms"),
      value: sorted.join(", "),
    });
  }

  if (selectedStage.value.length) {
    const values = selectedStage.value.map((v) => {
      const key = `search_filters.fr_stages.${v.replace(/ /g, "_")}`;
      return t(key) !== key ? t(key) : v;
    });
    chips.push({
      key: "stage",
      label: t("directory.filters.stage"),
      value: values.join(", "),
    });
  }

  if (selectedCompanies.value.length) {
    const values = selectedCompanies.value.map((v) => {
      const item = companyCheckboxes.value.find((c) => c.server_label === v);
      return item?.label ?? v;
    });
    chips.push({
      key: "provider",
      label: t("directory.filters.providers"),
      value: values.join(", "),
    });
  }

  if (selectedDocument.value) {
    chips.push({
      key: "documents",
      label: t("directory.filters.documents"),
      value: "✓",
    });
  }

  if (selectedRating.value.length) {
    const values = selectedRating.value.map((v) =>
      v === "null" ? t("search_filters.fr_no_ratings") : `${v}★`
    );
    chips.push({
      key: "rating",
      label: t("directory.filters.rating"),
      value: values.join(", "),
    });
  }

  if (q["tokenPrice[gte]"] != null || q["tokenPrice[lte]"] != null) {
    chips.push({
      key: "tokenPrice",
      label: t("directory.filters.price_range"),
      value: `$${q["tokenPrice[gte]"] ?? 0}–$${q["tokenPrice[lte]"] ?? "∞"}`,
    });
  }

  if (q["apr[gte]"] != null || q["apr[lte]"] != null) {
    chips.push({
      key: "apr",
      label: "APR",
      value: `${q["apr[gte]"] ?? 0}–${q["apr[lte]"] ?? "∞"}%`,
    });
  }

  if (q["irr[gte]"] != null || q["irr[lte]"] != null) {
    chips.push({
      key: "irr",
      label: "IRR",
      value: `${q["irr[gte]"] ?? 0}–${q["irr[lte]"] ?? "∞"}%`,
    });
  }

  if (
    q["minimumInvestment[gte]"] != null ||
    q["minimumInvestment[lte]"] != null
  ) {
    chips.push({
      key: "minimumInvestment",
      label: t("directory.filters.min_investment"),
      value: `$${q["minimumInvestment[gte]"] ?? 0}–$${
        q["minimumInvestment[lte]"] ?? "∞"
      }`,
    });
  }

  return chips;
});

const handleActiveChipRemove = (key: string) => {
  const [type] = key.split(":");
  switch (type) {
    case "country":
      handleCountryReset();
      return;
    case "subtype":
      handleSubtypeReset();
      return;
    case "bedroom":
      handleBedroomReset();
      return;
    case "bathroom":
      handleBathroomReset();
      return;
    case "stage":
      handleStageReset();
      return;
    case "provider":
      handleCompanyReset();
      return;
    case "rating":
      handleRatingReset();
      return;
    case "documents": {
      const item = documentsCheckboxes.value.find(
        (c) => c.server_label === "hasDocument"
      );
      if (item) handleDocumentsCheckboxClick(item);
      return;
    }
    case "tokenPrice":
      resetSliderFilter("price_range", "tokenPrice", [
        useFiltersStore.currentStats?.token?.priceMin ?? 0,
        useFiltersStore.currentStats?.token?.priceMax ?? 1,
      ]);
      return;
    case "apr":
      resetSliderFilter("apr", "apr", [
        useFiltersStore.currentStats?.aprMin ?? 0,
        useFiltersStore.currentStats?.aprMax ?? 100,
      ]);
      return;
    case "irr":
      resetSliderFilter("irr", "irr", [
        useFiltersStore.currentStats?.irrMin ?? 0,
        useFiltersStore.currentStats?.irrMax ?? 100,
      ]);
      return;
    case "minimumInvestment":
      resetSliderFilter("min_invest", "minimumInvestment", [
        useFiltersStore.currentStats?.minimumInvestment ?? 0,
        useFiltersStore.currentStats?.maximumInvestment ?? 100,
      ]);
      return;
  }
};

defineExpose({
  search,
  handleMobilSearch,
  debouncedHandleMobilSearch,
  objsAmount,
});

onMounted(async () => {
  isInitialLoading.value = true;
  try {
    await sortEstates(sortingFilters.value[0]);
    await updateFilters(false, {});
    ifCheckboxChecked();
    ifCanResetSliders();
    ifSearchQuery();
    updateFilters(false, transformQueryToObject(route.query));
  } finally {
    isInitialLoading.value = false;
  }

  eventBus.on("hero-search", (val: string) => {
    debouncedHandleMobilSearch(val);
  });
  eventBus.on("map-unit-selected", onMapUnitOpen);
  eventBus.on("map-unit-closed", onMapUnitClose);
});
onUnmounted(() => {
  sessionStorage.setItem("search-page-visited", "1");
  eventBus.off("hero-search");
  eventBus.off("map-unit-selected", onMapUnitOpen);
  eventBus.off("map-unit-closed", onMapUnitClose);
});
</script>

<style scoped lang="scss">
.dir-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  margin-bottom: 50px;
  padding-top: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

// Filter pills + active chips, pinned to the top of the viewport on desktop.
// Carries the filter bar's grey background so listings scroll cleanly beneath it.
.dir-page__sticky-head {
  position: sticky;
  top: 0;
  z-index: 30;
  display: flex;
  flex-direction: column;
  background: var(--header-bg);
}

.dir-page__content {
  display: block;
  width: 100%;
  &--split {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 24px;
    align-items: start;
  }
}

.dir-page__list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-width: 0;
}

.dir-page__sort {
  position: sticky;
  top: var(--dir-sticky-head-h, 0px);
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 12px 0;
  background: var(--white-monochrome);
  border-bottom: 1px solid var(--border-subtle);
}

.dir-page__sort-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

:deep(.dir-page__sort-button.base-button--light_bordered) {
  background-color: var(--surface);
  border-color: var(--border-subtle);
  box-shadow: none;
  &:hover {
    background-color: var(--surface);
    border-color: var(--border-strong);
  }
}

.dir-page__list-wrapper,
.dir-page__list-skeleton {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: stretch;
  width: 100%;
}

.dir-page__list-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: stretch;
  width: 100%;
}

// In the split map view the listing column is half the viewport, so the
// horizontal row card (≤ 720px) collapses to a vertical tile. Lay those tiles
// out two-per-row to use the column width instead of stacking single-file.
// Drops back to one column on narrower desktops where two tiles would be cramped.
.dir-page__content--split .dir-page__list-grid {
  display: grid;
  grid-template-columns: 1fr;
}

@media (min-width: 64rem) {
  .dir-page__content--split .dir-page__list-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.dir-page__map {
  position: sticky;
  top: calc(var(--dir-sticky-head-h, 116px) + 16px);
  height: calc(100dvh - var(--dir-sticky-head-h, 116px) - 32px);
  min-height: 480px;
}

// Pill styles live in the non-scoped block below so they apply to the
// element after it is teleported to <body>.

// In the split layout the listing column is half the viewport, so individual
// cards become narrow. The card itself reacts via a container query (see
// .listing-card--row in components/listing-card/index.vue) and switches to a
// vertical tile layout. The .dir-page__content--split grid block above then
// arranges those tiles two-per-row to fill the column.

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.sort-active {
  background-color: var(--white-transparent);
  border-color: var(--black-monochrome-72);
}

.search-skeleton {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: var(--shadow-light);
  &__list {
    width: 100%;
    height: 326px;
  }
}

@media (max-width: 56rem) {
  .dir-page {
    padding-top: 0;
    gap: 4px;
  }
  .dir-page__content--split {
    grid-template-columns: 1fr;
  }
  .dir-page__map {
    display: none;
  }
  // On mobile the site header is itself sticky and hides on scroll, so the
  // desktop pinned-filter behaviour is disabled to avoid a double-stuck header.
  .dir-page__sticky-head {
    position: static;
  }
  .dir-page__sort {
    position: static;
    padding: 4px 0 0;
    background: transparent;
    border-bottom: none;
  }
  .dir-page__list {
    gap: 12px;
  }
}
</style>

<style lang="scss">
// Directory page uses the full viewport width with 16px side gutters instead of
// the default 24px / 1440px-max-width applied to the rest of the app. Scoped
// styles can't reach the parent layout's .wrapper, so the override lives here.
.wrapper:has(.dir-page) {
  max-width: 100%;
  padding-left: 16px;
  padding-right: 16px;

  @media (max-width: 48rem) {
    padding-left: 16px;
    padding-right: 16px;
  }
}

// Lock page scroll while the fullscreen mobile map is open so swipes/pinches
// stay with the map and the listing underneath doesn't drift.
html:has(body.dir-page--map-scroll-locked),
body.dir-page--map-scroll-locked {
  overflow: hidden;
  overscroll-behavior: none;
  height: 100%;
}

// Mobile-only floating pill that toggles between list and map (Airbnb-style).
// Teleported to <body> so `position: fixed` is always relative to the viewport
// regardless of any ancestor that might create a containing block.
// Sits above fullscreen map overlay (z-index 9000) so it stays tappable.
.dir-page__map-toggle-pill {
  position: fixed;
  bottom: calc(20px + env(safe-area-inset-bottom, 0px));
  left: 50%;
  transform: translateX(-50%);
  z-index: 9500;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 20px;
  border: none;
  border-radius: var(--radius-pill);
  background: var(--text-primary);
  color: var(--surface);
  font-size: var(--font-small);
  font-weight: var(--fw-bold);
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.28);
  white-space: nowrap;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease;

  &:active {
    transform: translateX(-50%) translateY(1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.28);
  }
}

.sorting-menu {
  border-radius: 16px;
  border: 1px solid var(--black-monochrome-20, rgba(158, 167, 185, 0.4));
  background: var(--white-monochrome, #fff);
  box-shadow: 0 8px 24px rgba(17, 17, 17, 0.08);
  padding: 8px;
  width: 240px;
  max-height: none;
  overflow: hidden;

  .menu {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    width: 100%;
  }

  .list-container {
    width: 100%;

    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      width: 100%;
    }

    li {
      width: 100%;
      list-style: none;
    }

    button {
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between !important;
      gap: 12px;
      background: transparent;
      outline: none;
      border: none;
      padding: 10px 12px;
      border-radius: 10px;
      cursor: pointer;
      transition: background-color 0.15s ease;

      &:hover {
        background: var(--black-monochrome-04, rgba(17, 17, 17, 0.04));
      }

      p {
        margin: 0;
        text-align: left;
        flex: 1;
      }
    }

    .q-separator {
      margin: 4px 0;
      background: var(--black-monochrome-10, rgba(158, 167, 185, 0.2));
    }
  }
}
</style>
